const SHEET_URL = "https://script.google.com/macros/s/AKfycbywDRKbtPImyZLkQ39SDq4BC8FhG-GrP8PEsaHPXA3Mmkecslr0nlb1aua5rGHNUiud/exec";

export const savePartialOrder = async (data) => {
  try {
    await fetch(SHEET_URL, {
      method: "POST",
      mode: "no-cors",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...data, status: "partial" }),
    });
  } catch (err) {
    console.error("Partial save failed", err);
  }
};

export const saveConfirmedOrder = async (data) => {
  try {
    await fetch(SHEET_URL, {
      method: "POST",
      mode: "no-cors",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...data, status: "confirmed" }),
    });
  } catch (err) {
    console.error("Order save failed", err);
    throw err;
  }
};